var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechs3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1968 2.43007C15.5281 1.71835 16.6205 1.37684 18.3789 1.11182C20.9173 0.729225 23.2409 1.38749 24.7115 2.19884C28.4349 4.25311 32.6911 6.97505 35.3789 10.17C40.3981 16.1362 39.9463 30.0185 32.3785 34.5826C28.5857 36.87 23.668 37.8233 19.3081 38.2822C17.9491 38.4253 16.4902 38.0615 15.1704 37.7711C12.6982 37.2272 10.1337 36.3698 7.96588 35.0451C3.76556 32.4782 2.46476 28.1524 2.07571 23.4838C1.8951 21.3165 2.02542 18.6258 2.59901 16.5227C3.30563 13.9317 4.21444 12.1978 5.98221 10.17C8.49106 7.29224 10.7788 4.25728 14.1968 2.43007Z",
    stroke: "#8259F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 36C9 34.5471 9.80882 32.6692 10.2219 31.6945C11.9336 27.6556 14.8981 26.3127 17.2951 25.4156C19.5232 24.5817 21.7502 24.4615 23.9912 24.0253C24.9137 23.8457 25.4123 24.6718 26.2744 24.9671C27.9275 25.5334 29.4022 28.3571 30.4918 30.9021C31.0332 32.1667 31.7452 33.2867 32 34.9236",
    stroke: "#8259F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2063 12.7791C15.4656 13.6002 16.0653 14.7138 16.5414 15.5383C17.3481 16.9356 18.2611 17.7272 19.8155 17.926C21.6512 18.1608 24.7788 17.9497 25.6076 15.602C26.2342 13.827 26.2433 10.6144 24.6407 9.52118C23.2239 8.55477 21.3426 8.12256 19.6815 8.01425C18.7745 7.95511 17.7294 8.04059 17.2402 9.04363C16.6401 10.2743 15.8822 11.0372 15 12.015",
    stroke: "#8259F7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechs3);
export default __webpack_public_path__ + "static/media/techs3.c0d7cd87fd61809f06f56c25f4c9d151.svg";
export { ForwardRef as ReactComponent };